<template lang="pug">
  v-container#petitioner(fluid)
    h1.form-title2.pink-text Datos de la persona que solicita la asesoría
    v-layout.py-3(row wrap)
      v-container(xs-12 fluid)
        v-layout.py-1(row wrap)
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="name"
              ref="Nombre Completo"
              label="Nombre Completo"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="cellphone"
              ref="Número celular"
              label="Número celular"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="mail"
              ref="Mail"
              label="Mail"
              menu-props="auto"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="age"
              ref="Edad"
              label="Edad"
              menu-props="auto"
            )
            v-icon.visible(v-if="ageVisible" @click="visible('age')") visibility
            v-icon.visible(v-if="!ageVisible" @click="visible('age')") visibility_off
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              v-model="sex"
              :items="sexOptions"
              ref="Sexo"
              label="Sexo"
              menu-props="auto"
            )
            v-icon.visible(v-if="sexVisible" @click="visible('sex')") visibility
            v-icon.visible(v-if="!sexVisible" @click="visible('sex')") visibility_off
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="genre"
              ref="Genero"
              label="Género"
              :value="genre"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              v-model="occupation"
              :items="occupationOptions"
              autocomplete
              ref="Ocupación"
              label="Ocupación"
              menu-props="auto"
            )
            v-icon.visible(v-if="occupationVisible" @click="visible('occupation')") visibility
            v-icon.visible(v-if="!occupationVisible" @click="visible('occupation')") visibility_off
            v-tooltip.adjunct-label(top close-delay=1000)
              v-icon.ml-1.mb-1(slot="activator") info
              span.adjunct
                p Si tienes duda en como registrar el dato de "ocupación",
                p.m-0 no te olvides de revisar el anexo de ocupaciones.
                a(href="/static/documents/Atencion_Ax10_Ocupacion_160722.pdf" target="_blank") Ir al documento
          v-flex.pr-4.top-col(d-flex xs12 sm6 md4 v-if="showOtherOccupation")
            v-text-field(
              v-model="otherOccupation"
              label="Especificar Ocupación"
              :value="otherOccupation"
            )
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-select(
              v-model="civilStatus"
              :items="civilStatusOptions"
              ref="Estado Civil"
              label="Estado Civil"
              menu-props="auto"
            )
            v-icon.visible(v-if="civilStatusVisible" @click="visible('civilStatus')") visibility
            v-icon.visible(v-if="!civilStatusVisible" @click="visible('civilStatus')") visibility_off
          v-flex.pr-4(d-flex xs12 sm6 md4)
            v-text-field(
              v-model="ethnicity"
              label="Etnia"
              :value="ethnicity"
            )

</template>
<script>
export default {
  name: "Petitioner",
  props: {},
  data() {
    return {
      sexOptions: ["Hombre", "Mujer"],
      civilStatusOptions: [
        "Casado(a)",
        "Divorciado(a)",
        "En unión libre",
        "Separado(a)",
        "Soltero(a)",
        "Viudo(a)"
      ],
      occupationOptions: [
        "Abogado(a)",
        "Administrador(a)",
        "Gerente o Administrador(a) de…",
        "Agricultor(a)",
        "Albañil",
        "Ama de casa",
        "Trabajador(a) en la cría y cuidado de animales",
        "Carpintero(a)",
        "Comerciante",
        "Defensor(a) de DH",
        "Desempleado(a)",
        "Sacerdote",
        "Directivo(a) de ONG/OSC",
        "Gerente o Administrador(a) de…",
        "Diseñador(a) gráfico(a)",
        "Representante ejidal",
        "Empleado(a) de …",
        "Empleado(a) de comercio",
        "Empleado(a) de hotel",
        "Empleado(a) de ONG/OSC",
        "Empleado(a) en servicio doméstico",
        "Empleado(a) público(a)",
        "Empresario(a)",
        "Enfermero(a)",
        "Estudiante",
        "Fotógrafo(a)",
        "Gerente o Administrador(a) de…",
        "Gestor(a)… (especificar)",
        "Historiador(a)",
        "Jubilado(a)",
        "Maestro(a)",
        "Mecánico(a)",
        "Empresario(a)…",
        "Obispo",
        "Operario(a)",
        "Operario(a)",
        "Sacerdote",
        "Pensionado(a)",
        "Oficinista",
        "Recogedor(a) de reciclaje",
        "Religioso(a)",
        "Técnico(a) de aparatos electrodomésticos",
        "Representante de partido político",
        "Sacerdote",
        "Soldador(a)",
        "Vendedor(a) ambulante",
        "Sacerdote",
        "Otro"
      ],
      showOtherOccupation: false
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    options() {
      return this.$store.getters.options;
    },
    name: {
      get() {
        return this.$store.state.record.petitioner.name;
      },
      set(value) {
        this.$store.commit("updatePetitionerName", value);
      }
    },
    cellphone: {
      get() {
        return this.$store.state.record.petitioner.cellphone;
      },
      set(value) {
        this.$store.commit("updateCellphone", value);
      }
    },
    mail: {
      get() {
        return this.$store.state.record.petitioner.mail;
      },
      set(value) {
        this.$store.commit("updateMail", value);
      }
    },
    age: {
      get() {
        return this.$store.state.record.petitioner["age"];
      },
      set(value) {
        if (isNaN(value)) {
          this.$store.commit("updateAge", "");
        } else {
          this.$store.commit("updateAge", parseInt(value));
        }
      }
    },
    ageVisible: {
      get() {
        return this.$store.state.record.petitioner.ageVisible;
      },
      set(value) {
        this.$store.commit("updateAgeVisible", value);
      }
    },
    sex: {
      get() {
        return this.$store.state.record.petitioner.sex;
      },
      set(value) {
        this.$store.commit("updatePetitionerSex", value);
      }
    },
    sexVisible: {
      get() {
        return this.$store.state.record.petitioner.sexVisible;
      },
      set(value) {
        this.$store.commit("updateSexVisible", value);
      }
    },
    genre: {
      get() {
        return this.$store.state.record.petitioner.genre;
      },
      set(value) {
        this.$store.commit("updatePetitionerGenre", value);
      }
    },
    occupation: {
      get() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showOtherOccupation =
          this.$store.state.record.petitioner["occupation"] === "Otro"
            ? true
            : false;
        return this.$store.state.record.petitioner["occupation"];
      },
      set(value) {
        this.$store.commit("updateOtherOccupation", "");
        this.$store.commit("updateOccupation", value);
      }
    },
    occupationVisible: {
      get() {
        return this.$store.state.record.petitioner.occupationVisible;
      },
      set(value) {
        this.$store.commit("updateOccupationVisible", value);
      }
    },
    otherOccupation: {
      get() {
        return this.$store.state.record.petitioner.otherOccupation;
      },
      set(value) {
        this.$store.commit("updateOtherOccupation", value);
      }
    },
    civilStatus: {
      get() {
        return this.$store.state.record.petitioner.civilStatus;
      },
      set(value) {
        this.$store.commit("updateCivilStatus", value);
      }
    },
    civilStatusVisible: {
      get() {
        return this.$store.state.record.petitioner.civilStatusVisible;
      },
      set(value) {
        this.$store.commit("updateCivilStatusVisible", value);
      }
    },
    ethnicity: {
      get() {
        return this.$store.state.record.petitioner.ethnicity;
      },
      set(value) {
        this.$store.commit("updateEthnicity", value);
      }
    }
  },
  methods: {
    visible(item) {
      switch (item) {
        case "age":
          this.ageVisible = !this.ageVisible;
          break;
        case "sex":
          this.sexVisible = !this.sexVisible;
          break;
        case "occupation":
          this.occupationVisible = !this.occupationVisible;
          break;
        case "civilStatus":
          this.civilStatusVisible = !this.civilStatusVisible;
          break;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.adjunct-label {
  display: flex;
  align-items: center;
  i {
    font-size: 15px;
  }
}

.adjunct {
  p {
    color: white;
  }
  a {
    color: #F1BCDF !important;
  }
}
</style>
